import { towerVi } from "../../i18n/logictower.vi.ts";
import { vi } from "../../i18n/vi.ts";
import { Art } from "../components/common.tsx";

/** Drops in the kept line and the three-star target, under the level title. */
export function TowerHudLine({ drops, target, focus }: { drops: number; target: number; focus: boolean }) {
  return (
    <span className={`puzzle-hud__moves ${focus ? "hud-focus" : ""}`} data-testid="tower-drops">
      <Art id="tower.marble" className="ico-inline" />
      {towerVi.drops(drops)}
      <span className="puzzle-hud__target" aria-label={vi.puzzle.target(target)}>
        <Art id="icon.target" className="ico-inline" />
        {target}
      </span>
    </span>
  );
}
